import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
import { CertificateService } from 'app/core/components/content/certificate/certificate.service';
import { PreviewCertificate, Certificate } from 'app/core/components/content/certificate/certificate';
import { Observable } from 'rxjs/Observable';
import { ModalSize, SmartModalService } from 'app/core/services/smart-modal.service';
import { CertificatePreviewComponent } from 'app/core/components/content/certificate/preview/certificate-preview.component';
import { TranslateHandlebarsPipe } from 'app/shared/pipes/translate-handlebars.pipe';

export class ELearningCompletionCertificateCardConfiguration extends MaterialConfiguration {
    constructor(course: any, certificateService: CertificateService, modalService: SmartModalService, translateHandlebarsPipe: TranslateHandlebarsPipe) {
        super();
        this.tagType = 'completion-certificate';
        this.classType = 'Certificate';
        this.thumbnail = 'https://itpx-branded-portal-dev.s3.amazonaws.com/digital_certificate.png';
        this.subtitle = 'Digital Certificate'
        this.expired = course.expired;
        this.multiContent = false;
        this.clickable = false;
        this.target = [];
        this.links = [{
            disabled: false,
            tooltip: this.expired ? 'branded.portal.courses.assignment.ebook.download.tooltip' : null,
            url: this.expired ? '' : course.certLocation,
            text: 'branded.portal.courses.certificate.preview.text',
            type: LinkActions.ACTION,
            action: function (certificate) {
                return certificateService.getElearningCertificateHtml(certificate.id)
                    .map(body => body.data)
                    .switchMap(data => modalService.
                        open(CertificatePreviewComponent, {
                            text: data,
                            id: certificate.id,
                            eLearning: true
                        }, 'E-Learning certificate preview', ModalSize.Lg))
            }
        }, {
            disabled: false,
            tooltip: this.expired ? 'branded.portal.courses.assignment.ebook.download.tooltip' : null,
            url: this.expired ? '' : course.certLocation,
            text: 'branded.portal.courses.certificate.download.text',
            type: LinkActions.ACTION,
            action: (certificate) => certificateService.getElearningCertificateDownloadLink(certificate.id)
                .switchMap(res => certificateService.getCertificateFile(res.data.certLocation, certificate.displayName)),
            image: this.expired ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/download-inactive.svg' :
                'https://itpx-branded-portal-dev.s3.amazonaws.com/download.svg'
        }];
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/eLearning-certificate-card-configuration.ts